import { useCallback } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import config from '@/lib/config';
import { constructUrl } from '@/lib/utils';
import { accountService } from '@/lib/services';
import { useAccount, useAlert } from '@/hooks';
import { AsyncPage, FreshDeskLink } from '@/components';

export const SignInAndSecurity = () => {
	const { showAlert } = useAlert();
	const { account, setAccount } = useAccount();

	const fetchData = useCallback(async () => {
		const accountResponse = await accountService.getCurrentAccount().fetch();
		setAccount(accountResponse.account);
	}, [setAccount]);

	return (
		<AsyncPage fetchData={fetchData}>
			<Helmet>
				<title>Hackett Connect - Account - Sign In &amp; Security</title>
			</Helmet>
			<Row className="mb-6">
				<Col>
					<Card>
						<Card.Header>
							<Card.Title className="large">Sign In</Card.Title>
						</Card.Header>
						<Card.Body>
							<h3 className="mb-6">Email Address</h3>
							<Form.Group className="mb-6">
								<Form.Label>Current Email Address</Form.Label>
								<Form.Control type="email" value={account?.emailAddress} disabled readOnly />
							</Form.Group>
							<p className="mb-0">
								<FreshDeskLink className="font-weight-bold">Contact support</FreshDeskLink> to update
								your email address.
							</p>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			<Row>
				<Col>
					<Card>
						<Card.Header>
							<Card.Title className="large">Security</Card.Title>
						</Card.Header>
						<Card.Body>
							<h3 className="mb-6">Password</h3>
							<Button
								className="mb-6"
								variant="outline-primary"
								onClick={() => {
									if (config.HACKETT_ADVISORY_USE_REAL_AUTH === 'true') {
										window.location.href = constructUrl(
											`${config.HACKETT_ADVISORY_AUTH_UI_URL}/change-password`,
											{
												redirectUrl: encodeURIComponent(window.location.href),
												platform: 'hackett-connect',
											}
										);
									} else {
										showAlert({
											variant: 'warning',
											children: (
												<p className="mb-0">
													Environment not configured to support this feature.
												</p>
											),
										});
									}
								}}
							>
								Change Password
							</Button>
							<hr className="mb-6" />
							<h3 className="mb-6">Multi-Factor Authentication</h3>
							<Button
								variant="outline-primary"
								onClick={() => {
									if (config.HACKETT_ADVISORY_USE_REAL_AUTH === 'true') {
										window.location.href = constructUrl(
											`${config.HACKETT_ADVISORY_AUTH_UI_URL}/change-mfa-method`,
											{
												redirectUrl: encodeURIComponent(window.location.href),
												platform: 'hackett-connect',
											}
										);
									} else {
										showAlert({
											variant: 'warning',
											children: (
												<p className="mb-0">
													Environment not configured to support this feature.
												</p>
											),
										});
									}
								}}
							>
								Change MFA Method
							</Button>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</AsyncPage>
	);
};
